<template>
  <v-form>
    <v-container fluid>
      <v-divider  ></v-divider>
      <br>
      <div  class="ml-2">
        <h3 class="text-decoration-underline">{{ $t('menu.user.notificationsubscriber') }}</h3>
      </div>

      <v-row v-if="item" >
        <v-col md="12" v-for="notificationuser in item" :key="notificationuser.id">

          <v-row align="center" class="pa-0 ml-0">
            <v-col md="6" >
              <strong class="ml-4" >{{ $t(notificationuser.type.name) }}:</strong>
            </v-col>
            <v-col md="3" class="pa-0 ml-0">
              <v-switch
                v-model="notificationuser['enable']"
                :value="notificationuser['enable']"
                dense
                class="pa-0 ml-0"
                :label="$t('global.enable')"
              >
              </v-switch>

            </v-col>
            <v-col md="3" class="pa-0 ml-0">
              <v-switch
                v-model="notificationuser['sendEmail']"
                :value="notificationuser['sendEmail']"
                dense
                class="pa-0 ml-0"
                :label="$t('global.email')"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>
      </v-row>


    </v-container>
  </v-form>
</template>

<script>


import { validationMixin } from 'vuelidate';


export default {
  name: 'NotificationUserForm',
  mixins: [validationMixin],
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
        notificationuserValue: [],
    };
  },
  computed: {
    item() {
      return this.initialValues || this.values;
    },
  },
  methods: {


  },

};
</script>
